import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { isToday } from 'tools/date'
import breakpoint from 'tools/styled-components-breakpoint'

const DayContainer = styled.div`
  font-size: 13px;
  width: 2.5em;
  height: 2.5em;
  ${breakpoint('desktop')`
    width: 3.5em;
    height: 3.5em;
  `}
  padding: 0.25em;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  font-weight: ${props => props.today ? 'bold' : 'normal'};
  opacity: ${props => props.disabled ? 0.2 : 1};
  ${props => !props.disabled ? 'cursor: pointer;' : ''}
  color: ${props => props.selected ? '#fff' : '#000'};
  background: ${props => props.selected ? '#000' : 'transparent'};
  border-radius: 50%;
`
DayContainer.propTypes = {
  today: PropTypes.bool,
  disabled: PropTypes.bool,
  selected: PropTypes.bool
}

const DayText = styled.span`
  z-index: 999;
`

const Day = ({ day, selected, disabled }) => {
  const today = isToday(day)
  return (
    <DayContainer selected={selected} disabled={disabled} today={today}>
      <DayText>{day.getDate()}</DayText>
    </DayContainer>
  )
}
Day.propTypes = {
  ...DayContainer.propTypes,
  day: PropTypes.instanceOf(Date)
}

export default Day
